import type { TourConfig } from '../../types/tour.types'

// Sales Support Hub. The whole hub sits behind the BACK_OFFICE_INDEX permission
// (a `v-else` branch), so every anchored step targets an element that may be
// absent — each is marked optional and skips silently when not present.
const salesSupportHubTour: TourConfig = {
  id: 'sales-support-hub',
  title: 'Get help and resources fast',
  module: 'Account',
  routeName: 'SalesSupportHub',
  order: 23,
  autoStart: true,
  steps: [
    {
      id: 'intro',
      title: 'Your support toolkit in one place',
      body: 'The **Sales Support Hub** brings together the tools the TAMI team uses to support you — look up companies, estimate pricing and reach our data APIs — so you can self-serve answers without waiting on a reply.',
    },
    {
      id: 'directory',
      target: '[data-tour="ssh-directory"]',
      placement: 'bottom',
      // Hub content is gated by the BACK_OFFICE_INDEX permission.
      optional: true,
      title: 'Look up any company',
      body: 'The **Company Directory** lets you search and inspect company records directly — the quickest way to confirm what data TAMI holds on an account.',
    },
    {
      id: 'pricing',
      target: '[data-tour="ssh-pricing"]',
      placement: 'bottom',
      optional: true,
      title: 'Estimate pricing in seconds',
      body: 'Use the **Pricing Calculator** to model plans and volumes, so you can quote the right package without a back-and-forth.',
    },
    {
      id: 'api',
      target: '[data-tour="ssh-api"]',
      placement: 'bottom',
      optional: true,
      title: 'Connect via our APIs',
      body: 'The **API Access** tab gathers the links and keys you need to integrate TAMI data into your own tools and workflows.',
    },
  ],
}

export default salesSupportHubTour
